import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { useFlags } from '@lyrahealth-inc/shared-app-logic'

import { getCustomerSubdomain } from '../data/customer/customerSelectors'
import { getHasFetchedUser } from '../data/login/loginSelector'
import { getIsUserLoggedIn } from '../data/user/userSelectors'

export const useSubdomainRedirection = (isLaunchDarklyIdentified?: boolean) => {
  const hasFetchedUser = useSelector(getHasFetchedUser)
  const isUserLoggedIn = useSelector(getIsUserLoggedIn)
  const customerSubdomain = useSelector(getCustomerSubdomain)
  const { isSubdomainRedirectionEnabled } = useFlags()

  useEffect(() => {
    // Wait for LaunchDarkly to be identified with customer context before redirecting
    if (!isLaunchDarklyIdentified) {
      return
    }

    if (!customerSubdomain) {
      return
    }

    // for logged out users, we want to redirect to the correct subdomain if it differs from the current host
    const currentHost = window.location.host

    // Extract customer from current URL (format: {customer}.**.lyrahealth.com or {customer}.localhost:4000)
    const currentCustomer = currentHost.split('.')[0]

    if (
      isSubdomainRedirectionEnabled &&
      hasFetchedUser && // currentuser is loaded
      !isUserLoggedIn && // user is logged out
      currentCustomer !== customerSubdomain
    ) {
      // Replace the customer part while preserving the rest of the domain
      const newHost = currentHost.replace(/^[^.]+/, customerSubdomain)
      const subdomainURL = `https://${newHost}${window.location.pathname}${window.location.search}`
      window.location.replace(subdomainURL)
    }
  }, [isLaunchDarklyIdentified, isSubdomainRedirectionEnabled, hasFetchedUser, isUserLoggedIn, customerSubdomain])
}
